import { tryParseJSON } from '@eventr/common'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { CardText } from '../subComponents/cardText'
import { RowInfoFiles } from '../subComponents/rowInfoFiles'
import { RowInfoNotes } from '../subComponents/rowInfoNotes'
interface FlightPersonalItemsProps {
    baggage_allowance?: string
    documents?: string
    notes?: string
}

export const FlightPersonalItems = ({
    baggage_allowance,
    documents,
    notes,
}: FlightPersonalItemsProps) => {
    const files = useMemo(() => {
        if (!documents) return []
        return tryParseJSON(documents, []) as string[]
    }, [documents])

    if (!files.length && !notes && !baggage_allowance) return null
    return (
        <Stack spacing={'8px'}>
            <CardText variant="bodyBold">
                {cardTranslation('Personal Items')}
            </CardText>

            {baggage_allowance && <RowInfoNotes notes={baggage_allowance} />}

            {notes && <RowInfoNotes notes={notes} />}
            {files && <RowInfoFiles files={files} />}
        </Stack>
    )
}
